import React, { useContext, useEffect } from 'react';
import SearchBar from '../../components/search-bar/SearchBar';
import DirectoryCardArea from '../../components/directory-card-area/DirectoryCardArea';
import DirectoryList from '../../components/directory-list/DirectoryList';
import HeaderControls from '../../components/header-controls/HeaderControls';
import { AppContext } from '../../context/AppContext';
import { IAppContext } from '../../context/DefaultAppState';
import initializeApp from '../../lib/initialization';
import { renderCmsIdNumber } from '../../lib/util';
import moment from 'moment';

const HomePage = () => {
  const appContext = useContext(AppContext);

  useEffect(() => {
    appContext.updateSelectedSpecialty('');
    appContext.updateName('');
    appContext.updateLocation('');
  }, []);

  return (
    <>
      <div className="header-container">
        <h1 className="header-message">Find health care professionals in your area</h1>
        <HeaderControls />
      </div>
      <div className="body-container">
        <h3 className="search-message">Please select what you would like to search. </h3>
        <DirectoryCardArea />
        <SearchBar />
        {appContext.isDisabled && appContext.search.isValidZIP && appContext.search.required === false ? (
          <div className={'required'}>
            <p></p>
            <p>Please input a valid ZIP Code.</p>
            <p></p>
          </div>
          
        ) : null}
        {appContext.isDisabled && !appContext.search.isValidZIP && appContext.search.required === false ? (
          <div className={'required'}>
            <p></p>
            <p>Please input a valid ZIP Code or leave it blank.</p>
            <p></p>
          </div>
        ) : null}
        <DirectoryList />
      </div>
    </>
  );
};

export default HomePage;
